
import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//     value: 'Diflux'
// }

export const nameOfAppSlice = createSlice({
    name: 'app name',
    initialState: { value: 'Fanonix' },
    reducers: {
        addName: (state, action)=>{
            // execute code here
            state.value = 'fundrise';
        }
    }
});


export const { addName } = nameOfAppSlice.actions;

export default nameOfAppSlice.reducer;
